import { css } from '@emotion/css';
import { baseTheme } from '@streamlain/theme';

export const dateCellStyle = css({
  display: 'flex',
  alignItems: 'center',
  width: '100%',
  padding: '0',
  border: 'none',
  fontFamily: baseTheme.fontSansFamily,
  color: 'var(--streamlain-text-primary-color)',
  fontWeight: '400',
  backgroundColor: 'transparent',
  fontSize: 'var(--data-view-cell-text-size)',
  lineHeight: 'var(--data-view-cell-text-line-height)',
  height: 'var(--data-view-cell-text-line-height)',
});

export const dateValueContainerStyle = css({
  padding: '12px',
  backgroundColor: 'var(--layer-background-primary)',
  borderRadius: '12px',
  color: 'var(--text-secondary)',
  fontSize: '17px',
  lineHeight: '22px',
  height: '30px',
});

export const datePickerContainerStyle = css({
  padding: '12px',
  backgroundColor: 'var(--layer-background-primary)',
  borderRadius: '12px',
});

export const dateTimePickerContainerStyle = css({
  backgroundColor: 'var(--layer-background-primary)',
  border: '1px solid var(--streamlain-border-color)',
  borderRadius: '12px',
  display: 'flex',
  flexDirection: 'column',
  padding: '10px',
  width: 'min(320px, calc(100vw - 32px))',
});

export const dateTimeFooterStyle = css({
  alignItems: 'stretch',
  display: 'flex',
  flexDirection: 'column',
  gap: '10px',

  '& > div:first-child': {
    minWidth: 0,
  },

  '& > div:last-child': {
    background: 'var(--streamlain-background-secondary-color)',
    border: '1px solid var(--streamlain-border-color)',
    borderRadius: '10px',
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
    minWidth: 0,
    padding: '10px',
  },
});

export const dateTimeInputRowStyle = css({
  color: 'var(--streamlain-text-secondary-color)',
  display: 'flex',
  flexDirection: 'column',
  fontSize: '12px',
  gap: '6px',
});

export const dateTimeInputStyle = css({
  flex: '1 1 auto',
  minWidth: 0,
  height: '28px',
  border: '1px solid var(--streamlain-border-color)',
  borderRadius: '6px',
  background: 'var(--streamlain-background-primary-color)',
  color: 'var(--streamlain-text-primary-color)',
  fontFamily: baseTheme.fontSansFamily,
  fontSize: '13px',
  padding: '0 8px',
});

export const dateTimeQuickButtonStyle = css({
  background: 'var(--streamlain-background-primary-color)',
  border: '1px solid var(--streamlain-border-color)',
  borderRadius: '6px',
  color: 'var(--streamlain-text-secondary-color)',
  cursor: 'pointer',
  fontFamily: baseTheme.fontSansFamily,
  fontSize: '12px',
  height: '28px',
  padding: '0 8px',

  ':hover': {
    background: 'var(--streamlain-hover-color)',
    color: 'var(--streamlain-text-primary-color)',
  },
});

export const dateTimeQuickRowStyle = css({
  display: 'grid',
  gap: '6px',
  gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',

  '& > span': {
    color: 'var(--streamlain-text-secondary-color)',
    fontSize: '12px',
    gridColumn: '1 / -1',
    lineHeight: '16px',
  },
});
